import Axios from "../../utils/tms-axios/tms-axios";
import ReportsAxios from "../../utils/tms-axios/tms-reports-axios";
const TmsDarshanamService = {
  getDarshanam: async (page, limit) => {
    const resp = await Axios.get(
      `darshanam/all/${localStorage.getItem(
        "templeId"
      )}?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  createDarshanam: async (body) => {
    const resp = await Axios.post(`darshanam/new`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteDarshanam: async (productId) => {
    const resp = await Axios.delete(`darshanam/delete/${productId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  viewDarshanam: async (productId) => {
    const resp = await Axios.get(`darshanam/by-id?darshanamId=${productId}`, {
      headers: {
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  editDarshanam: async (productId, body) => {
    const resp = await Axios.put(`darshanam/update/${productId}`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    return resp.data;
  },

  //darshanam-slots
  getDarshanamSlots: async (id) => {
    const resp = await Axios.get(`darshanam/slots/byDarshanamId/${id}`, {
      headers: {
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  createDarshanamSlots: async (body) => {
    const resp = await Axios.post(`darshanam/slots/new`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  editDarshanamSlots: async (body) => {
    const resp = await Axios.put(`darshanam/slots/edit`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  deleteDarshanamSlots: async (slotId) => {
    const resp = await Axios.delete(`darshanam/slots/delete/${slotId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  updateTerms: async (productId, termsData, onlineterms, ticketType) => {
    const resp = await Axios.patch(
      `darshanam/metadata/${productId}`,
      {
        termsAndConditions: termsData,
        onlineTermsAndConditions: onlineterms,
        ticketType: ticketType ? "mini_ticket" : "full_ticket",
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  //darshanam-slots-counters

  //darshanam-slots
  getDarshanamSlotCounter: async (id) => {
    const resp = await Axios.get(
      `darshanam-counter/counters/BySlotId?darshanamSlotId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  createDarshanamSlotCounter: async (body) => {
    const resp = await Axios.post(`darshanam-counter/counters/new`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  editDarshanamSlotCounter: async (body) => {
    const resp = await Axios.put(`darshanam-counter/counters/edit`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  deleteDarshanamSlotCounter: async (slotId) => {
    const resp = await Axios.delete(
      `darshanam-counter/counters/darshanamSlotCounterId/${slotId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  //darshanam booking

  fetchDarshanamBookingSlots: async (tickets, bookingDate) => {
    const resp = await Axios.get(
      `darshanam-counter/counter-query?tickets=${tickets}&bookingDate=${bookingDate}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  fetchProtocolDarshanam: async () => {
    const resp = await Axios.get(`darshanam-online-booking/valid-products`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  fetchProtocolSlots: async (fromDate, toDate, multipleProductIds) => {
    let url = `darshanam-slot-daily-quota?fromDate=${fromDate}&toDate=${toDate}&multipleProductIds=${multipleProductIds}&type=protocol`;
    // &onlyOnlineEnabled=false&type=protocol${multipleProductIds
    //   .map((item) => `&multipleProductIds=${Number(item)}`)
    //   .join("")}
    const resp = await Axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  darshanamBooking: async (body, paymentType = "CASH") => {
    const resp = await Axios.post(
      `cart-counter/darshanam`,
      {
        darshanamBookings: body,
        multiTicketsLinked: false,
        paymentType: paymentType,
        cashRemarks: "string",
        cashReference: "string",
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  darshanamReport: async ({
    format,
    tableCurrentPage,
    tablePageSize,
    fromDate,
    toDate,
    dateType,
    sortType,
    counter,
    shift,
    slot,
    darshanamType,
  }) => {
    let query = `/darshanam-report/bookings?page=${tableCurrentPage}&limit=${tablePageSize}&bookingFromDate=${fromDate}&bookingToDate=${toDate}&dateType=${dateType}`;

    if (counter && counter !== "") {
      query += `&counterId=${counter}`;
    }
    if (shift && shift !== "") {
      query += `&counterShiftTimingId=${shift}`;
    }
    if (slot && slot !== "") {
      query += `&darshanamSlotId=${slot}`;
    }
    if (darshanamType && darshanamType !== "") {
      query += `&productId=${darshanamType}`;
    }
    const axios = format === "email" ? Axios : ReportsAxios;
    const resp = await axios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    return resp.data;
  },
  darshanamReportOnline: async ({
    format,
    tableCurrentPage,
    tablePageSize,
    fromDate,
    toDate,
    dateType,
    sortType,
    counter,
    shift,
    slot,
    darshanamType,
    paymentStatus,
    selectedPartner,
  }) => {
    let query = `darshanam-online-report/booking?format=${format}&paymentStatus=${paymentStatus}&page=${tableCurrentPage}&limit=${tablePageSize}&bookingFromDate=${fromDate}&bookingToDate=${toDate}&dateType=${dateType}&order=${sortType}`;

    if (counter && counter !== "") {
      query += `&counterId=${counter}`;
    }
    if (shift && shift !== "") {
      query += `&counterShiftTimingId=${shift}`;
    }
    if (slot && slot !== "") {
      query += `&darshanamSlotId=${slot}`;
    }
    if (darshanamType && darshanamType !== "") {
      query += `&productId=${darshanamType}`;
    }
    if (selectedPartner !== "" && selectedPartner) {
      query += `&partnerCode=${selectedPartner}`;
    }
    const axios = format === "email" ? Axios : ReportsAxios;
    const resp = await axios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  //disable-dates
  fetchdisabledates: async (productId, page, limit) => {
    const resp = await Axios.get(
      `darshanam/disable/date?darshanamId=${productId}&page=${page}&limit=${limit}&templeId=${localStorage.getItem(
        "templeId"
      )}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  createDisableDates: async (
    productIds,
    startDate,
    endDate,
    description,
    onlineDisabled,
    counterDisabled
  ) => {
    const resp = await Axios.post(
      `darshanam/disable/date`,
      {
        productIds: productIds,
        startDate: startDate,
        endDate: endDate,
        description: description,
        onlineDisabled: onlineDisabled,
        counterDisabled: counterDisabled,
        protocolDisabled: false,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    return resp.data;
  },

  deleteDisableDate: async (id) => {
    const resp = await Axios.delete(`darshanam/disable/delete?id=${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    return resp.data;
  },
  getConsolidateReport: async ({
    format,
    productId,
    from,
    to,
    counter,
    shift,
    groupBy,
    bookingType,
  }) => {
    let query = `darshanam-counter-report/consolidated-ticket-collection-for-product?format=${format}&bookingFromDate=${from}&bookingToDate=${to}`;

    if (productId !== "") {
      query += `&productId=${productId}`;
    }
    if (counter) {
      query += `&counterId=${counter}`;
    }
    if (shift) {
      query += `&counterShiftTimingId=${shift}`;
    }
    if (groupBy !== "") {
      query += `&groupBy=${groupBy}`;
    }
    if (bookingType) {
      query += `&dateType=${bookingType}`;
    }
    let res = await ReportsAxios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return res.data;
  },

  getOnlineConsolidateReport: async ({
    format,
    productId,
    from,
    to,
    groupBy,
    bookingType,
  }) => {
    let query = `darshanam-online-report/consolidated-ticket-collection-for-product?format=${format}&bookingFromDate=${from}&bookingToDate=${to}`;

    if (productId !== "") {
      query += `&productId=${productId}`;
    }
    if (groupBy !== "") {
      query += `&groupBy=${groupBy}`;
    }
    if (bookingType) {
      query += `&dateType=${bookingType}`;
    }
    let res = await ReportsAxios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return res.data;
  },

  getQuotaData: async ({ from, to, productIds, type }) => {
    const resp = await Axios.get(
      `darshanam-slot-daily-quota?fromDate=${from}&toDate=${to}&productSlotId=${productIds}&type=${type}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  updateQuotaData: async (body) => {
    const res = await Axios.post(`darshanam-slot-daily-quota`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return res.data;
  },
  getPartnersForDarshanam: async (productId) => {
    const resp = await Axios.get(`darshanam/partners/${productId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  darshnamPartnerAccess: async (body) => {
    const resp = await Axios.patch(`darshanam/partner-access`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
};

export default TmsDarshanamService;
